import styled, { css } from 'styled-components'
import { Flex } from 'components'

export const Divider = styled(Flex)(
  ({ whiteBorder }) => css`
    border: ${whiteBorder && `${whiteBorder}px solid white`};
  `,
)
